import apiCall from "@/func/net/apiCall";
import { Dict, SfStoreDiscount, SfStoreProduct } from "@/types/generalTypes";
import { computed, ref } from "vue";

const storeState = ref({
  products: null as Dict<SfStoreProduct> | null,
  discounts: null as Dict<SfStoreDiscount> | null,
});

export const storeProducts = computed(() => {
  if (!storeState.value.products) {
    refreshProducts();
  }
  return storeState.value.products;
});

export const storeDiscounts = computed(() => {
  if (!storeState.value.discounts) {
    refreshDiscounts();
  }
  return storeState.value.discounts;
});

export const discountedIndividualCost = computed(() => {
  if (!storeState.value.products) {
    refreshProducts();
    return "";
  }
  if (!storeState.value.discounts) {
    refreshDiscounts();
    return "";
  }
  return (
    storeState.value.products.individualSpelling?.cost +
    storeState.value.products.individualMaths?.cost +
    storeState.value.products.individualMathsWs?.cost -
    storeState.value.discounts.individualFullCombo?.discount
  );
});

export const discountedSchoolCost = computed(() => {
  if (!storeState.value.products) {
    refreshProducts();
    return "";
  }
  if (!storeState.value.discounts) {
    refreshDiscounts();
    return "";
  }
  return (
    storeState.value.products.classSpelling?.cost +
    storeState.value.products.classMaths?.cost -
    storeState.value.discounts.spellingMathsClassCombo?.discount
  );
});

const refreshProducts = async () => {
  storeState.value.products = {};
  const data = await apiCall("store-product");
  if (data.success) {
    const newP = {} as Dict<SfStoreProduct>;
    for (const op of data.data.items) {
      newP[op.name] = op as SfStoreProduct;
    }
    storeState.value.products = newP;
  }
};

const refreshDiscounts = async () => {
  storeState.value.discounts = {};
  const data = await apiCall("store-discount");
  if (data.success) {
    const newD = {} as Dict<SfStoreDiscount>;
    for (const op of data.data.items) {
      newD[op.name] = op as SfStoreDiscount;
    }
    storeState.value.discounts = newD;
  }
};
